import { c as _c } from "react/compiler-runtime";
import { Avatar, Badge, Box, Button, Card, HStack, List, Separator, Text, VStack, Wrap } from '@chakra-ui/react';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { SpecialtyTag } from '@src/components/sco/Advisors/shared/SpecialtyTag';
import { asksFromMatch, categoryMetaFromMatch, founderDisplayName, founderFromMatch, founderSubtitleFromMatch, hasAppliedToSeat, matchFactorTitles, matchPercentLabel, openSeatProfileHref, seatApplicationState, seatTitleFromMatch, skillTitlesFromMatch, whyTextFromMatch, type OpenSeatMatch, type SeatApplicationState } from '@src/components/sco/Advisors/utils/openSeatMatches';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { useRouter } from 'next/router';
import { LuArrowRight } from 'react-icons/lu';
type OpenSeatMatchCardProps = {
  match: OpenSeatMatch;
};
const APPLICATION_BADGE: Record<Exclude<SeatApplicationState, 'none'>, {
  label: string;
  colorPalette: string;
}> = {
  pending: {
    label: 'Applied',
    colorPalette: 'blue'
  },
  accepted: {
    label: 'Accepted',
    colorPalette: 'green'
  },
  declined: {
    label: 'Declined',
    colorPalette: 'red'
  }
};
export const OpenSeatMatchCard = t0 => {
  const $ = _c(102);
  const {
    match
  } = t0;
  const router = useRouter();
  const paths = useAdvisorsPaths();
  const userMatchId = match.userMatchId;
  let t1;
  if ($[0] !== match) {
    t1 = founderFromMatch(match);
    $[0] = match;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const founder = t1;
  let t2;
  if ($[2] !== match) {
    t2 = categoryMetaFromMatch(match);
    $[2] = match;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const category = t2;
  let T0;
  let T1;
  let T2;
  let applied;
  let href;
  let t10;
  let t11;
  let t12;
  let t13;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== category || $[5] !== founder || $[6] !== match || $[7] !== paths.base || $[8] !== router || $[9] !== userMatchId) {
    const skills = skillTitlesFromMatch(match);
    const factors = matchFactorTitles(match, 8);
    const asks = asksFromMatch(match);
    let t14;
    if ($[26] !== match) {
      t14 = whyTextFromMatch(match);
      $[26] = match;
      $[27] = t14;
    } else {
      t14 = $[27];
    }
    const why = t14;
    let t15;
    if ($[28] !== match) {
      t15 = matchPercentLabel(match);
      $[28] = match;
      $[29] = t15;
    } else {
      t15 = $[29];
    }
    const pct = t15;
    let t16;
    if ($[30] !== paths.base || $[31] !== userMatchId) {
      t16 = openSeatProfileHref(userMatchId, paths.base);
      $[30] = paths.base;
      $[31] = userMatchId;
      $[32] = t16;
    } else {
      t16 = $[32];
    }
    href = t16;
    const applicationState = seatApplicationState(match);
    applied = hasAppliedToSeat(match);
    const applicationBadge = applicationState === "none" ? null : APPLICATION_BADGE[applicationState];
    let t17;
    if ($[33] !== match) {
      t17 = seatTitleFromMatch(match);
      $[33] = match;
      $[34] = t17;
    } else {
      t17 = $[34];
    }
    const seatTitle = t17;
    const showNeed = asks.length > 0 || !!why || skills.length > 0;
    T2 = Card.Root;
    t11 = "hidden";
    t12 = "interactive";
    if ($[35] !== href || $[36] !== router) {
      t13 = () => router.push(href);
      $[35] = href;
      $[36] = router;
      $[37] = t13;
    } else {
      t13 = $[37];
    }
    T1 = Card.Body;
    t8 = 0;
    t9 = 0;
    let t18;
    if ($[38] !== applicationBadge) {
      t18 = applicationBadge ? <Badge colorPalette={applicationBadge.colorPalette} textStyle="label2xs" variant="subtle">{applicationBadge.label}</Badge> : null;
      $[38] = applicationBadge;
      $[39] = t18;
    } else {
      t18 = $[39];
    }
    let t19;
    if ($[40] !== seatTitle) {
      t19 = <Text fontSize="xs" fontWeight="semibold" lineClamp={2}>{seatTitle}</Text>;
      $[40] = seatTitle;
      $[41] = t19;
    } else {
      t19 = $[41];
    }
    let t20;
    if ($[42] !== t18 || $[43] !== t19) {
      t20 = <VStack align="start" flex={1} gap={1.5} minWidth={0}>{t18}{t19}</VStack>;
      $[42] = t18;
      $[43] = t19;
      $[44] = t20;
    } else {
      t20 = $[44];
    }
    let t21;
    if ($[45] !== category || $[46] !== pct) {
      t21 = pct ? <Badge colorPalette={category.palette} textStyle="label2xs" variant="subtle">{pct}</Badge> : null;
      $[45] = category;
      $[46] = pct;
      $[47] = t21;
    } else {
      t21 = $[47];
    }
    let t22;
    if ($[48] !== t20 || $[49] !== t21) {
      t22 = <HStack align="center" bgColor="colorPalette.card/40" gap={2} justify="space-between" padding={3}>{t20}{t21}</HStack>;
      $[48] = t20;
      $[49] = t21;
      $[50] = t22;
    } else {
      t22 = $[50];
    }
    let t23;
    if ($[51] !== match) {
      t23 = founderDisplayName(match);
      $[51] = match;
      $[52] = t23;
    } else {
      t23 = $[52];
    }
    let t24;
    if ($[53] !== t23) {
      t24 = <Avatar.Fallback name={t23} />;
      $[53] = t23;
      $[54] = t24;
    } else {
      t24 = $[54];
    }
    let t25;
    if ($[55] !== founder) {
      t25 = founder?.pictureUrl ? <Avatar.Image src={founder.pictureUrl} /> : null;
      $[55] = founder;
      $[56] = t25;
    } else {
      t25 = $[56];
    }
    let t26;
    if ($[57] !== t24 || $[58] !== t25) {
      t26 = <Avatar.Root size="lg">{t24}{t25}</Avatar.Root>;
      $[57] = t24;
      $[58] = t25;
      $[59] = t26;
    } else {
      t26 = $[59];
    }
    let t27;
    if ($[60] !== match) {
      t27 = founderDisplayName(match);
      $[60] = match;
      $[61] = t27;
    } else {
      t27 = $[61];
    }
    let t28;
    if ($[62] !== t27) {
      t28 = <Text fontSize="md" fontWeight="medium" lineClamp={1}>{t27}</Text>;
      $[62] = t27;
      $[63] = t28;
    } else {
      t28 = $[63];
    }
    let t29;
    if ($[64] !== match) {
      t29 = founderSubtitleFromMatch(match);
      $[64] = match;
      $[65] = t29;
    } else {
      t29 = $[65];
    }
    let t30;
    if ($[66] !== t29) {
      t30 = <Text color="colorPalette.fg/60" fontSize="xs" lineClamp={1}>{t29}</Text>;
      $[66] = t29;
      $[67] = t30;
    } else {
      t30 = $[67];
    }
    let t31;
    if ($[68] !== t28 || $[69] !== t30) {
      t31 = <VStack align="start" flex={1} gap={0} minWidth={0}>{t28}{t30}</VStack>;
      $[68] = t28;
      $[69] = t30;
      $[70] = t31;
    } else {
      t31 = $[70];
    }
    let t32;
    if ($[71] !== t26 || $[72] !== t31) {
      t32 = <HStack align="center" gap={3} paddingTop={4} paddingX={4}>{t26}{t31}</HStack>;
      $[71] = t26;
      $[72] = t31;
      $[73] = t32;
    } else {
      t32 = $[73];
    }
    if ($[74] !== t22 || $[75] !== t32) {
      t10 = <VStack align="stretch" gap={0}>{t22}{t32}</VStack>;
      $[74] = t22;
      $[75] = t32;
      $[76] = t10;
    } else {
      t10 = $[76];
    }
    T0 = VStack;
    t3 = "stretch";
    t4 = 4;
    t5 = 6;
    t6 = showNeed ? <VStack align="stretch" gap={4}><VStack align="stretch" gap={2}><Text color="colorPalette.fg/70" textStyle="labelXs">What they need</Text>{asks.length > 0 ? <List.Root color="colorPalette.fg/70" fontFamily="longform" fontSize="sm" paddingInlineStart="4">{asks.slice(0, 3).map(_temp)}</List.Root> : why ? <Text color="colorPalette.fg/70" fontFamily="longform" fontSize="sm" lineClamp={3}>{why}</Text> : null}</VStack>{skills.length > 0 ? <Box><Text color="colorPalette.fg/70" marginBottom={2} textStyle="labelXs">Advisor Skills</Text><Wrap gap={1.5}>{skills.map(s => <SpecialtyTag key={s} colorPalette={category.palette} label={s} />)}</Wrap></Box> : null}</VStack> : null;
    t7 = factors.length > 0 ? <VStack align="stretch" gap={2}><Text color="colorPalette.fg/70" textStyle="labelXs">Match factors</Text><Wrap gap={1.5}>{factors.map(_temp2)}</Wrap></VStack> : null;
    $[4] = category;
    $[5] = founder;
    $[6] = match;
    $[7] = paths.base;
    $[8] = router;
    $[9] = userMatchId;
    $[10] = T0;
    $[11] = T1;
    $[12] = T2;
    $[13] = applied;
    $[14] = href;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    T0 = $[10];
    T1 = $[11];
    T2 = $[12];
    applied = $[13];
    href = $[14];
    t10 = $[15];
    t11 = $[16];
    t12 = $[17];
    t13 = $[18];
    t3 = $[19];
    t4 = $[20];
    t5 = $[21];
    t6 = $[22];
    t7 = $[23];
    t8 = $[24];
    t9 = $[25];
  }
  let t14;
  if ($[77] !== T0 || $[78] !== t3 || $[79] !== t4 || $[80] !== t5 || $[81] !== t6 || $[82] !== t7) {
    t14 = <T0 align={t3} gap={t4} padding={t5}>{t6}{t7}</T0>;
    $[77] = T0;
    $[78] = t3;
    $[79] = t4;
    $[80] = t5;
    $[81] = t6;
    $[82] = t7;
    $[83] = t14;
  } else {
    t14 = $[83];
  }
  let t15;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Separator />;
    $[84] = t15;
  } else {
    t15 = $[84];
  }
  const t16 = applied ? "View application" : "View seat";
  let t17;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <LuArrowRight />;
    $[85] = t17;
  } else {
    t17 = $[85];
  }
  let t18;
  if ($[86] !== href || $[87] !== t16) {
    t18 = <HStack justify="flex-end" padding={4}><Button asChild={true} size="sm" variant="cta" onClick={_temp3}><NextLink href={href}>{t16}{t17}</NextLink></Button></HStack>;
    $[86] = href;
    $[87] = t16;
    $[88] = t18;
  } else {
    t18 = $[88];
  }
  let t19;
  if ($[89] !== T1 || $[90] !== t10 || $[91] !== t14 || $[92] !== t18 || $[93] !== t8 || $[94] !== t9) {
    t19 = <T1 gap={t8} padding={t9}>{t10}{t14}{t15}{t18}</T1>;
    $[89] = T1;
    $[90] = t10;
    $[91] = t14;
    $[92] = t18;
    $[93] = t8;
    $[94] = t9;
    $[95] = t19;
  } else {
    t19 = $[95];
  }
  let t20;
  if ($[96] !== T2 || $[97] !== t11 || $[98] !== t12 || $[99] !== t13 || $[100] !== t19) {
    t20 = <T2 overflow={t11} variant={t12} onClick={t13}>{t19}</T2>;
    $[96] = T2;
    $[97] = t11;
    $[98] = t12;
    $[99] = t13;
    $[100] = t19;
    $[101] = t20;
  } else {
    t20 = $[101];
  }
  return t20;
};
function _temp(ask) {
  return <List.Item key={ask}>{ask}</List.Item>;
}
function _temp2(f) {
  return <SpecialtyTag key={f} colorPalette="colorPalette" label={f} />;
}
function _temp3(event) {
  return event.stopPropagation();
}